import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.Wallets.BankStatementReportPopupContent', {
    title: 'Bank statement report',
    description: 'Fill in the fields to download the report',
    download: 'Download',
    lastWeek: 'Last week',
    lastMonth: 'Last month',
    lastYear: 'Last year',
    custom: 'Custom',
    reportDateRange: 'Report date range',
    from: 'From',
    to: 'To',
    datePlaceholder: 'Select Date...',
    currency: 'Currency',
    currencyPlaceholder: 'Select currency...',
    fileFormat: 'File format',
    fileFormatPlaceholder: 'Select file format...',
    pdf: 'PDF',
    csv: 'CSV',
});
